// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"sp_a bhp_rc bhp_qx bhp_xr","ContestPosts__more":"sp_b bhp_vu bhp_b bhp_va bhp_sv"};